import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Link from 'react-toolbox/lib/link'
import { Flex } from 'reflexbox'

import styles from './styles.scss'

const NavigationLink = (props) => {
  const {
    active,
    label,
    onClick,
  } = props
  const linkClass = active ? 'active' : 'inactive'

  return (
    <Flex styleName={linkClass} align='center'>
      <Link onClick={onClick} theme={styles} label={label}/>
    </Flex>
  )
}

NavigationLink.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
}

NavigationLink.defaultProps = {
  active: false,
  label: '',
}

export default CSSModules(styles, NavigationLink)
